import React from "react";
import { getTranslations } from "../../Common/utils";
import { MiniLeagueMatchTimer } from "../Overlays/MiniLeague/matchTimer";
import { LeagueCard } from "../LeagueCard";

const MiniLeagueCardInfo = ({ MiniLeagueCardInfoConfig }) => {
  const {
    locktime,
    showMaxTeams = false,
    leagueData,
    leagueId,
  } = MiniLeagueCardInfoConfig;

  return (
      <div className="si-miniLeagueCardBox">
        <LeagueCard
          data={{
            ...leagueData,
            leagueType: "Mini",
            teamCount: 1,
            maxMemberCount:
              leagueData?.maxMem === 99999999
                ? getTranslations(
                    "league_card_total_team_unlimited",
                    "Unlimited"
                  )
                : leagueData?.maxMem,
          }}
          showJoinCta={false}
          showLeagueBanner={false}
          showMiniInfo={false}
          hideRanks={true}
          showRightIcon={false}
          showMaxTeams={true}
        />
        {!!locktime && <MiniLeagueMatchTimer locktime={locktime} />}
        {getTranslations(`league_description_${leagueId}`) && (
          <div
            dangerouslySetInnerHTML={{
              __html: getTranslations(`league_description_${leagueId}`),
            }}
          />
        )}
      </div>
  );
};

export { MiniLeagueCardInfo };
